// Filename: src/OtherServices/index.js
import React, { useState, useRef } from "react";
import { Typography, Icon } from "../index";
import { Box, Grid, Link, Accordion, AccordionSummary, AccordionDetails, makeStyles } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import * as constants from "../constants";

const OtherServices = (props) => {
  const country = props.country.toLowerCase();
  const brand = props.brand;
  const classes = useStyles();
  const [expandAdditionalDetails, setExpandedAdditionalDetails] = useState(false);
  const myRef = useRef(null);

  const handleLinkClick = (event) => {
    event.preventDefault();
    const brandDomainMap = {
      Hertz: "hertz",
      Ace: "acerentalcars",
      Dollar: "dollarcarrental",
      Thrifty: "thrifty",
      Firefly: "acerentalcars",
    };
    const domain = brandDomainMap[brand] || "hertz";
    const url = `https://myjourney.${domain}.${country === "nz" ? "co" : "com"}.${country}/checkin`;
    window.open(url, "_blank");
  };

  return (
    <Accordion
      className={classes.accordion}
      expanded={expandAdditionalDetails}
      onChange={() => setExpandedAdditionalDetails(!expandAdditionalDetails)}
      ref={myRef}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ fontSize: 36 }} />}
        aria-controls={`panel1a-content`}
        id={`panel1a-header`}
        className={classes.summary}
      >
        <Typography className={classes.headerFont} variant={"h3"}>
            Other Services
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Box style={{ textAlign: "center" }}>
          {/* <Typography variant="h2">
            <Link onClick={handleLinkClick}>Other Services</Link>
          </Typography> */}
          <Grid container spacing={1} style={{ marginTop: 30, textAlign: "center" }}>
            {/* Online check in icon/link (Ace only) */}
            {props.brand === "Ace" ? (
              <Grid item xs={4} md={3}>
                <a href={constants.ACE_ONLINE_CHECK_IN[country]} rel="noreferrer" target="_blank">
                  <Icon src={constants.ACE_ONLINE_CHECK_IN_ICON} />
                  <Typography style={{ overflowWrap: "anywhere" }}>Online Check-In</Typography>
                </a>
              </Grid>
            ) : (
              ""
            )}
            {/* Brand's website icon/link */}
            <Grid item xs={4} md={3}>
              <a
                href={
                  props.brand === "Ace"
                    ? constants.ACE_URL[country]
                    : props.brand === "Firefly"
                    ? constants.FIREFLY_URL
                    : constants.HERTZ_URL[country]
                }
                rel="noreferrer"
                target="_blank"
              >
                <Icon
                  src={
                    props.brand === "Ace"
                      ? constants.ACE_URL_ICON
                      : props.brand === "Firefly"
                      ? constants.FIREFLY_URL_ICON
                      : constants.HERTZ_URL_ICON
                  }
                />
                <Typography style={{ overflowWrap: "anywhere" }}>
                  {props.brand === "Ace"
                    ? `AceRentalCars.${country === "nz" ? "co" : "com"}.${country}`
                    : props.brand === "Firefly"
                    ? "Firefly.com"
                    : "Hertz.com"}
                </Typography>
              </a>
            </Grid>
            {/* Fleet Guide icon/link */}
            {props.brand === "Hertz" || props.brand === "Ace" ? (
              <Grid item xs={4} md={3}>
                <a
                  href={
                    props.brand === "Ace"
                      ? constants.ACE_FLEET_GUIDE[country]
                      : constants.HERTZ_FLEET_GUIDE[country]
                  }
                  rel="noreferrer"
                  target="_blank"
                >
                  <Icon
                    src={
                      props.brand === "Ace"
                        ? constants.ACE_FLEET_GUIDE_ICON
                        : constants.HERTZ_FLEET_GUIDE_ICON
                    }
                  />
                  <Typography>Fleet Guide</Typography>
                </a>
              </Grid>
            ) : (
              ""
            )}
            {/* Products & Services icon/link */}
            {props.brand === "Hertz" || props.brand === "Ace" ? (
              <Grid item xs={4} md={3}>
                <a
                  href={
                    props.brand === "Ace"
                      ? constants.ACE_PRODUCTS_AND_SERVICES[country]
                      : constants.HERTZ_PRODUCTS_AND_SERVICES[country]
                  }
                  rel="noreferrer"
                  target="_blank"
                >
                  <Icon
                    src={
                      props.brand === "Ace"
                        ? constants.ACE_PRODUCTS_AND_SERVICES_ICON
                        : constants.HERTZ_PRODUCTS_AND_SERVICES_ICON
                    }
                  />
                  <Typography>Products & Services</Typography>
                </a>
              </Grid>
            ) : (
              ""
            )}
            {/* Location information icon/link */}
            <Grid item xs={4} md={3}>
              <a
                href={
                  props.brand === "Ace"
                    ? constants.ACE_LOCATIONS[country]
                    : props.brand === "Firefly"
                    ? constants.FIREFLY_LOCATIONS
                    : constants.HERTZ_LOCATIONS[country]
                }
                rel="noreferrer"
                target="_blank"
              >
                <Icon
                  src={
                    props.brand === "Ace"
                      ? constants.ACE_LOCATIONS_ICON
                      : props.brand === "Firefly"
                      ? constants.FIREFLY_LOCATIONS_ICON
                      : constants.HERTZ_LOCATIONS_ICON
                  }
                />
                <Typography>Location information</Typography>
              </a>
            </Grid>
            {/* Hertz FAQ */}
            {props.brand === "Hertz" && ["AU", "au"].includes(props.country) ? (
              <Grid item xs={4} md={3}>
                <a href={constants.HERTZ_FAQ[country]} rel="noreferrer" target="_blank">
                  <Icon src={constants.HERTZ_FAQ_ICON} />
                  <Typography>FAQ</Typography>
                </a>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme) => ({
  accordion: {
    marginLeft: 10,
    marginRight: 10,
    boxShadow: "none",
    "&.Mui-expanded": {
      margin: 10,
    },
    "&::before": {
      display: "none", // ✅ removes the grey line
    },
  },
  headerFont: {
    color: "#a0a0a0",
  },
  summary: {
    backgroundColor: "#ffffff00",
  },
  removeContainer: {
    ".pac-container:after": {
      content: "none !important",
    },
  },
  icon: {
    width: "150px",
  },
}));

export default OtherServices;
